import Cookies from "js-cookie";
import { apiService, setAuthHeader } from "./api";
import { ACCESS_TOKEN_KEY, COOKIES_COMPANY_ID } from "../utils/constants";

export async function fetchWebsocketURL() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(
    `/company/${companyId}/load-chat/websocket-url/`
  );
  return response.data["url"];
}

export async function fetchChats(status: "active" | "archived") {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(
    `/company/${companyId}/load-chat?status=${status}&role=carrier`
  );

  return response.data["chats"];
}

export async function sendMessageAPI(chatID: string, message: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);
  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/load-chat/${chatID}/messages`,
    { senderRole: "carrier", content: message }
  );

  return response.data;
}

export async function getCompanyDetails(companyId: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  setAuthHeader(token!);
  const response = await apiService.get(
    `/company?type=getCompanyDetails&companyId=${companyId}`
  );
  return response.data;
}
